export default __webpack_public_path__ + "static/media/print-mobile-6.1d28ef3a.png";